module.exports = __webpack_public_path__ + "img/costa-rica.41a8307b.svg";